import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0b3c609c&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=0b3c609c&prod&scoped=true&lang=less&"
import style1 from "./App.vue?vue&type=style&index=1&id=0b3c609c&prod&lang=less&"
import style2 from "./App.vue?vue&type=style&index=2&id=0b3c609c&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c609c",
  null
  
)

export default component.exports